<template>
<div class="tile is-ancestor">
  <div class="tile is-vertical is-5">
    <div class="tile">
      <div class="tile is-parent is-vertical">
        <article class="tile is-child notification ">
          <p class="title">Member</p>
          <p class="subtitle">Main &amp; Sub</p>
          <div class="content">
            MainMember<br>
            団長：朝凪（あさなぎ）<br>
            副団長：玉置（たまき）<br>
            アナゴ<br>
            石ゐ一輝<br>
            らみゅ<br>
            白山<br>
            リンハイ<br>
            SubMember<br>
            舞来（むく）<br>
            犬鳴（いぬなき）<br>
          </div>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification is-info">
          <p class="title">Middle tile</p>
          <p class="subtitle">With an image</p>
          <figure class="image is-4by3">
            <img src="https://bulma.io/images/placeholders/640x480.png">
          </figure>
        </article>
      </div>
    </div>
    <div class="tile is-parent is-vertical">
      <article class="tile is-child notification is-vertical">
        <p class="title">Wide tile</p>
        <p class="subtitle">Aligned with the right tile</p>

      </article>
    </div>
  </div>
  <div class="tile is-parent">
    <article class="tile is-child notification is-success">
      <div class="content">
        <p class="title">Tall tile</p>
        <p class="subtitle">With even more content</p>
        <div class="content">
          <!-- Content -->
        </div>
      </div>
    </article>
  </div>
</div>
</template>
<script>
export default {
  props: {

  },
  watch: {

  },
  methods: {

  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/member.vue